import {
	setBill,
	setCardToken,
	setDiscount,
	setError,
	setPayPalToken,
} from '../../../../../redux/slices/userSlice'
import { paramsToQuery } from '../../../../../utils/historyDecorators'
import { ampEventWithEventProperty } from '../../../../../utils/amplitude'

export function payPalHandler(
	history,
	dispatch,
	total,
	annualPlan,
	pathname,
	user_id,
	alternativePurchase,
	isLegalFlow,
	upsell_test,
	initial_price,
) {
	return function (e) {
		if (e?.detail?.data?.order?.status) {
			ampEventWithEventProperty('paypal_handler', {
				data: e?.detail?.data?.order?.status,
			})
		}
		if (
			e?.detail?.data?.order?.status === 'approved' ||
			e?.detail?.data?.order?.status === 'void_ok'
		) {
			dispatch(
				setBill({
					type: 'PAYPAL',
					total,
					annual: annualPlan,
					alternativePurchase,
					isABTest: initial_price === 'flow_99',
				}),
			)
			dispatch(setPayPalToken({ payPalToken: e?.detail?.data?.order?.token }))
			if (alternativePurchase !== -1) {
				history.push({
					pathname: '/success',
					search: paramsToQuery({ user_id, external_id: user_id }),
				})
			} else {
				history.push({
					pathname: '/upsell1',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}
			document.body.style.overflow = 'visible'
		}
		if (
			(e?.type === 'order-processed' &&
				e?.detail?.data?.order?.status === 'declined') ||
			e?.detail?.data?.order?.status === 'auth_failed'
		) {
			ampEventWithEventProperty('paypal_handler_error', {
				data: e.detail?.data?.error?.recommended_message_for_user,
			})
			dispatch(
				setError({
					error: e.detail?.data?.error?.recommended_message_for_user,
				}),
			)
			if (alternativePurchase !== -1) {
				history.push({
					pathname: '/error',
					search: paramsToQuery({ user_id, external_id: user_id }),
				})
			} else {
				dispatch(setDiscount({ discount: pathname }))
				history.push({
					pathname: `/error`,
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}
			document.body.style.overflow = 'visible'
			document.body.style.overflow = 'visible'
		}
	}
}

export function cardHandler(
	history,
	dispatch,
	total,
	annualPlan,
	pathname,
	user_id,
	alternativePurchase,
	isLegalFlow,
	upsell_test,
	initial_price,
) {
	return function (e) {
		if (e?.data?.response?.order?.status) {
			ampEventWithEventProperty('card_handler', {
				data: e?.data?.response?.order?.status,
			})
		}
		if (
			e?.data?.response?.order?.status === 'approved' ||
			e?.data?.response?.order?.status === 'void_ok'
		) {
			dispatch(
				setBill({
					type: 'CARD',
					total,
					annual: annualPlan,
					alternativePurchase,
					isABTest: initial_price === 'flow_99',
				}),
			)
			dispatch(
				setCardToken({
					cardToken:
						e.data.response?.transactions[
							Object.keys(e.data?.response?.transactions)[0]
						]?.card?.card_token?.token ||
						e.data?.response?.transactions[
							Object.keys(e.data?.response?.transactions)[1]
						]?.card?.card_token?.token,
				}),
			)
			if (alternativePurchase !== -1) {
				history.push({
					pathname: '/success',
					search: paramsToQuery({ user_id, external_id: user_id }),
				})
			} else {
				history.push({
					pathname: '/upsell1',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}
			document.body.style.overflow = 'visible'
		}
		if (
			e.data.type === 'orderStatus' &&
			(e.data.response.order.status === 'declined' ||
				e.data.response.order.status === 'auth_failed')
		) {
			ampEventWithEventProperty('card_handler_error', {
				data: e.data.response.error.recommended_message_for_user,
			})
			dispatch(
				setError({ error: e.data.response.error.recommended_message_for_user }),
			)
			dispatch(setDiscount({ discount: pathname }))
			if (alternativePurchase !== -1) {
				history.push({
					pathname: '/error',
					search: paramsToQuery({ user_id, external_id: user_id }),
				})
			} else {
				history.push({
					pathname: '/error',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}
			document.body.style.overflow = 'visible'
		}
	}
}
